require('../others/wolmart');

Wolmart.$body.on("click", ".search-order", function (e) {
    e.preventDefault();
    Wolmart.popup({ items: { src: jQuery(e.currentTarget).data("link") } }, "login");
});

